import React, {useState, useEffect} from 'react';
import {useSelector} from "react-redux";
import axios from 'axios';
import querystring from 'querystring';
import CircularProgress from '@material-ui/core/CircularProgress';
import NotificationItem from './NotificationItem';
import CustomScrollbars from '../../utils/CustomScrollbars';

const Circular = () => (
  <div className="w-100 text-center" style={{height: 'calc(100vh - 120px)'}}>
      <CircularProgress/>
  </div>
);

const AppNotification = ({ open }) => {
  const { authUser } = useSelector(({auth}) => auth);
  const { languageSelected } = useSelector(({settings}) => settings);
  const [notifications, setNotifications] = useState();
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const params = {
        company: authUser.company !== "#" ? authUser.company : "",
        salesmanCode: authUser.salesman !== "#" ? authUser.salesman : "",
        language: languageSelected.id
      }
      let queryString = querystring.stringify(params);
      const url = `${process.env.REACT_APP_API_URL}post/notification?${queryString}`;

      setLoading(true);

      try {
        const result = await axios(url, {headers: {"Authorization": `Bearer ${localStorage.getItem('x-access-token')}`}});
        setNotifications(result.data);
      }catch (error) {
          console.log(error);
      }

      setLoading(false);
    }

    if(open)
      fetchData();
      
  }, [authUser, languageSelected, open])

  return (
    <CustomScrollbars className="messages-list scrollbar" style={{height: 280}}>
      <ul className="list-unstyled">
      { loading ? <Circular /> : "" }
        {notifications && notifications.map((notification, index) => <NotificationItem key={index} notification={notification}/>)
        }
      </ul>
    </CustomScrollbars>
  )
};

export default AppNotification;

